
import _debounce from "lodash/debounce";
import { store } from 'Store/store.index';
import { changeUrlArg, storageGetItem, storageSetItem } from "Utils/utils";

// WEBSDK localStorage
export const WEBSDK_LOCAL_KEYS = [
  'bookmark_default_appearance',
  'thumbnail_move_page_show_preview'
];
// event constants
export const EV_APP_ERROR = 'ev-app-error';

// web monitor config begin
export const FILTERS_URLS = [
  // TODO FOXIT 去除统计
  // 'apm-eck-us.connectedpdf.com',
  // 'www.google-analytics.com',
  'hm.baidu.com',
  // 'sockjs-node/info',
  // 'sockjs-node/',
  // 'cpdfapi/v1/client/exception-log',
  // 'jaeger-dashboard',//'jaeger-dashboard-test.connectedpdf.com'
  // 'stats.g.doubleclick.net',
  // 'www.googletagmanager.com'
];
// 
export const FILTERS_REGS = [
  /\/\/account\S+\/api\/file/, // user avatar
]

export function createMonitorConfig() {
  window.__errors__ = [];
  let errId = 1;
  let browserId;
  browserId = storageGetItem(localStorage, 'fx__browser_monitor_id')
  if (!browserId) {
    browserId = new Date().getTime();
    storageSetItem(localStorage, 'fx__browser_monitor_id', browserId)
  }
  // 
  const eventEmitFn = (function () {
    // return fn to caller
    return _debounce(() => {
      store.appStore.emitEvent(EV_APP_ERROR);
    }, 10000, {
      leading: false, // true => false
      trailing: true
    })
  })();

  let MONITOR_CONFIG = {
    jsError: true,
    resourceError: true,
    ajaxError: true,
    consoleError: false, // console.error默认不处理
    scriptError: false, // 跨域js错误，默认不处理，因为没有任何信息
    vue: false,
    autoReport: true,
    filters: [
      function (error) {
        //filter post api
        //|| error.category !== "ajax"
        if (!error || !error.data || !error.data.url) {
          return false;
        }
        if (typeof error.data.url !== 'string') {
          console.warn(">>> MONITOR >>> receive, filters -> e", error)
          return false;
        }
        let isMatch;
        if (FILTERS_URLS.length > 0) {
          isMatch = FILTERS_URLS.some(function (url) {
            return error.data.url.indexOf(url) !== -1;
          })
          if(isMatch){
            return true
          }
        }
        if (FILTERS_REGS.length > 0) {
          isMatch =  FILTERS_REGS.some(function (reg) {
            return reg.test(error.data.url);
          })
          if(isMatch){
            return true
          }
        }
        return false;
      }
    ], // 过滤器，命中的不上报
    levels: ["info", "warn", "error"],
    category: ["js", "resource", "ajax"],
    // {data:{url,...}, category}
    /** 
     * @param {Object} error 
     * @param {String} error.level one of "info", "warn", "error"
     * @param {Object} error.data 
     * @param {String} error.category ["js", "resource", "ajax", ...]
     * 
    */
    sendError: function (error) {

      if (store.appStore.isOnPremiseDeployMode) {
        // on premise, do not send error to server
        return;
      }


      try {
        let isFilter = this.filters.some(function (func) {
          return typeof func === "function" && func.call(this, error);
        })
        if (isFilter) {
          return;
        }
        // replace token
        if (typeof error.data.url === 'string' && error.data.url.indexOf('access_token') !== -1) {
          error.data.url = changeUrlArg(error.data.url, 'access_token', '***')
        }

        let _errId = errId++;
        let errItem = { id: _errId, type: error.category, data: error.data, level: !!error.level ? error.level : 'error', browserId };
        typeof errItem.data === 'object' && (errItem.data.browserId = browserId);
        window.__errors__.push(errItem);
        eventEmitFn && eventEmitFn();
      } catch (e) {
        console.error(">>> MONITOR >>> receive, catch -> e", e)
      }
    }
  };
  window.__monitor_config__ = MONITOR_CONFIG;
  // add listener
  store.appStore.onCatchAppError(window.__monitor_config__);

  return MONITOR_CONFIG;
}
// web monitor config end